var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusWithBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.56 133"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M144 133H35.55A35.59 35.59 0 010 97.45v-61.9A35.59 35.59 0 0135.55 0H144a35.6 35.6 0 0135.56 35.55v61.9A35.6 35.6 0 01144 133zM35.55 4A31.59 31.59 0 004 35.55v61.9A31.59 31.59 0 0035.55 129H144a31.6 31.6 0 0031.56-31.56V35.55A31.6 31.6 0 00144 4z",
    fill: "#1253fa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5",
    fill: "#0b4ffa",
    d: "M87.78 39.5h4v54h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6",
    fill: "#0b4ffa",
    d: "M63.85 64.5h51v4h-51z"
  })))));
}
export default SvgPlusWithBorder;